import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'
import { H2, Text1 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'

export type SystemErrorProps = {
  type?: 'med' | 'personal'
}

const SystemError: React.FC<SystemErrorProps> = ({
  type,
}: SystemErrorProps) => {
  const { t } = useTranslation()
  return (
    <Layout header={<AppBarCommon type={type} />}>
      <CenteredContainer
        header={<H2>{t('errors.YaDoc Quickを使用することができません')}</H2>}
      >
        <Text1>{t('errors.時間を置いて再度アクセスしてください')}</Text1>
      </CenteredContainer>
    </Layout>
  )
}

SystemError.defaultProps = {
  type: 'med',
}

export const ZoomConnectionError: React.FC<{
  mode: 'token' | 'temporary'
}> = ({ mode }) => {
  const { t } = useTranslation()

  const message =
    mode === 'temporary'
      ? {
          header: t('errors.現在一時的にZoomへの接続ができません。'),
          text: t(
            'errors.再接続を行いますのでこのまましばらくお待ちください。'
          ),
        }
      : {
          header: t(
            'errors.医療機関側の準備ができていません。しばらく時間をおいてからもう一度ビデオ通話を開始してください。'
          ),
          text: t(
            'errors.しばらく時間をおいても繋がらない場合は、医療機関へお問い合わせください。'
          ),
        }

  return (
    // 受診者のみのためpersonalで固定
    <Layout header={<AppBarCommon type={'personal'} />}>
      <CenteredContainer maxWidth="xl" header={<H2>{message.header}</H2>}>
        <Text1>{message.text}</Text1>
      </CenteredContainer>
    </Layout>
  )
}

export default SystemError
